import React, { useCallback } from 'react';
import { GenericConfirmationModal } from '@ydistri/ds';

interface DeleteAsoModalProps {
  modalTitle: string;
  message: string;
  dataTestId: string;
  confirmLoading: boolean;
  onCancel: () => void;
  onConfirm: () => PromiseLike<unknown>;
}

const DeleteAsoModal: React.FC<DeleteAsoModalProps> = ({
  modalTitle,
  message,
  dataTestId,
  confirmLoading,
  onCancel,
  onConfirm,
}) => {
  const handleConfirm = useCallback(() => {
    onConfirm().then(() => {
      onCancel();
    });
  }, [onCancel, onConfirm]);

  return (
    <GenericConfirmationModal
      data-testid={dataTestId}
      title={modalTitle}
      message={message}
      onConfirmed={handleConfirm}
      onCanceled={onCancel}
      running={confirmLoading}
      confirmationButtonLabel="Delete"
    />
  );
};

export default DeleteAsoModal;
